import { cn } from "@core-ui/utils/cn";
import { forwardRef } from "react";

export interface GlassPanelFrameProps extends React.HTMLAttributes<HTMLDivElement> {
	header?: React.ReactNode;
}

export const GlassPanelFrame = forwardRef<HTMLDivElement, GlassPanelFrameProps>((props, ref) => {
	const { className, header, children, ...otherProps } = props;
	return (
		<div
			className={cn("relative flex min-h-0 flex-1 flex-col overflow-hidden rounded-[inherit]", className)}
			ref={ref}
			{...otherProps}
		>
			{header && <div className="h-[46px] shrink-0" />}
			{children}
			{header}
		</div>
	);
});
